import { useEffect } from 'react'
import { useAuth0 } from 'app/Auth'
import { useAuthActions } from 'store/auth/auth.store'

const Logout = () => {
  const { logout } = useAuth0()
  const { handleLogout } = useAuthActions()

  useEffect(() => {
    const performLogout = async () => {
      handleLogout(() => {
        logout({ returnTo: `${window.location.origin}/?status=loggedout` })
      })
    }

    performLogout()
  }, [handleLogout, logout])

  return null
}
export default Logout
